/*
 * All constant related to Project config here
 */
export const paymentConstant = {
    STRIPE: 'STRIPE',
    PADDLE: 'PADDLE',
    LEMONSQUEEZY: 'LEMONSQUEEZY',
    PERCENT100: 'PERCENT100',
    CLEVERBRIDGE: 'CLEVERBRIDGE',
    VERIFONE: 'VERIFONE',
};
export const paymentOrderStatus = {
    DRAFT: 'DRAFT',
    PAYMENT_PENDING: 'PAYMENT_PENDING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    CREATED: 'CREATED',
};
export const paymentOrderItemStatus = {
    CANCELLED: 'CANCELLED',
    CREATED: 'CREATED',
};
export const driveScheduleStatus = {
    SCHEDULED: 'SCHEDULED',
    ONGOING: 'ON_GOING',
    CANCEL: 'CANCEL',
    CONCLUDED: 'CONCLUDED',
};
export const candidateAvailabilityStatus = {
    AVAILABLE: 'available',
};
export const paymentTransactionStatus = {
    INITIATED: 'INITIATED',
    PENDING: 'PENDING',
    FAILED: 'FAILED',
    COMPLETED: 'COMPLETED',
    REFUND_INITIATED: 'REFUND_INITIATED',
    REFUND_PENDING: 'REFUND_PENDING',
    REFUND_FAILED: 'REFUND_FAILED',
    REFUND_COMPLETED: 'REFUND_COMPLETED',
};
export const driveOccurrenceGuestStatus = {
    INVITED: 'INVITED',
    REGISTERED: 'REGISTERED',
    READY: 'READY',
    IN: 'IN',
    OUT: 'OUT',
    WAITING: 'WAITING',
    BOOKED: 'BOOKED',
    CANCELLED: 'CANCELLED',
    INACTIVE: 'IN_ACTIVE',
};
export const SKUPlanType = {
    PAY_BOOK: 'PAY_NOW',
    BOOK_PAY: 'PAY_LATER',
};
export const regexPatterns = {
    numbersOnly: /^\d*$/, // Matches only numbers (0-9)
    lettersOnly: /^[A-Za-z]*$/, // Matches only letters (A-Z, a-z)
    lowercaseOnly: /^[a-z]*$/, // Matches only lowercase letters
    uppercaseOnly: /^[A-Z]*$/, // Matches only uppercase letters
    alphanumeric: /^[A-Za-z0-9]*$/, // Matches letters and numbers
    email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/, // Matches a valid email format
    phoneNumber: /^\+?[0-9]{7,15}$/, // Matches international phone numbers (7-15 digits, optional +)
    noSpecialChars: /^[A-Za-z0-9 ]*$/, // Allows letters, numbers, and spaces (no special characters)
    strongPassword: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/, // At least 8 chars, 1 uppercase, 1 lowercase, 1 number, 1 special char
};
export const importantLinks = {
    support: 'mailto:support@talview.com',
    supportEmail: 'support@talview.com',
};
export const assessmentQuesType = {
    VIDEO: 'video',
    ASYNC: 'ASYNC',
    OBJECTIVE: ['multiple_choice_answer', 'multiple_choice', 'objective'],
    LONG_FORM: 'LONG_FORM',
    EXTERNAL: 'EXTERNAL',
    IVY: 'IVY',
    CODING: ['coding test', 'coding'],
    FITB: 'FILL_IN_THE_BLANK',
};
export const externalDeliveryType = {
    IFRAME: 'IFRAME',
    NEW_TAB: 'NEW_TAB',
    NEW_WINDOW: 'NEW_WINDOW',
    EMBEDDED: 'EMBEDDED',
};
export const participationMeetingStatus = {
    YET_TO_JOIN: 'YET_TO_JOIN',
    WAITING: 'WAITING',
    IN_MEETING: 'IN_MEETING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    NO_SHOW: 'NO_SHOW',
    RUNNING_LATE: 'RUNNING_LATE',
    DRAFT: 'DRAFT',
    SCHEDULED: 'SCHEDULED',
    IN_PROGRESS: 'IN_PROGRESS',
    ONGOING: 'ONGOING',
    CANNOT_ALLOCATE: 'CANNOT_ALLOCATE',
};
// Ivy visual cues regex
export const sectionRegex = /\*\s+\*\*(.*?):\*\*\s+(.*?)(?=\*\s+\*\*|$)/gs;
export const QUESTION_NOT_FOUND = 'Question not found';
// share and available days only allow 13 days
export const MAX_DAYS_AHEAD = 13;
export const dayHeaders = [
    { key: 'sun', shortName: 'S' },
    { key: 'mon', shortName: 'M' },
    { key: 'tue', shortName: 'T' },
    { key: 'wed', shortName: 'W' },
    { key: 'thu', shortName: 'T' },
    { key: 'fri', shortName: 'F' },
    { key: 'sat', shortName: 'S' },
];
export const MEDIUM_DEVICE_WIDTH = 768;
export const calendarVariant = {
    DEFAULT: 'default',
    AVAILABILITY: 'availability',
};
export const SLOT_SUMMARY_HEADER_CONFIG = {
    showTitleLogo: true,
    logoClassName: 'mr-2 h-6 w-6 text-green-600',
};
export const ASSESSMENT_DURATION = 60;
export const ORDER_STATE = {
    INIT: 'INIT',
    BOOKING: 'BOOKING',
    PAYMENT: 'PAYMENT',
};
export const V8 = 'v8';
export const paymentStepRouteMap = {
    PAYMENT: 'details',
    PAYMENT_PENDING: 'pending',
    PAYMENT_COMPLETED: 'completed',
};
export const codeRunnerStatus = {
    COMPLETED: 'COMPLETED',
    ACCEPTED: 'ACCEPTED',
};
